<section class="copy-code-container" *ngIf="code">
    <section class="code-container">
        <span class="code">{{code}}</span>
        <mdk-btn
            [buttonText]="'REFERRALS.COPY_BUTTON' | translate"
            (buttonClick)="onClickCopy()"
        ></mdk-btn>
    </section>
</section>
